<template>
  <static-fullscreen-card>
    <template v-slot:header></template>
    <template v-slot:actions>
      <a-btn-refresh @click="$refs.table.updateData()" />
      <a-btn-add :icon="'far fa-plus-square'" :title="'Создать документ'" v-if="getAccess('documents.cashOut.create')" @click="createNew()" />
    </template>
    <portal to="v-main">
      <CashDialog ref="cashDialog" @updateData="$refs.table.updateData()" />
      <select-dialog v-model="showSelectDialog" v-if="showSelectDialog" :operations="operations" @select="onSelectOperation($event)" />
    </portal>
    <a-table-f-api
      ref="table"
      :api="url"
      :model="getModelList(m)"
      :useQuery="false"
      :defaults="defaults"
      @click="onClickRow($event)"
      @rowContextMenu="onRowContextMenu($event)"
      @update-data="getBalance($event.filters)"
    >
    </a-table-f-api>
    <context-menu ref="rowContextMenu" :items="contextMenuItems" @clickData="onContextMenuClick($event)" />
  </static-fullscreen-card>
</template>

<script>
import { getAccess, genModel, keyDetect } from "@/components/mixings";
import libsCash from "./libsCash";

export default {
  mixins: [getAccess, genModel, libsCash, keyDetect],
  components: {
    CashDialog: () => import("./dialogs/cashDialog"),
    selectDialog: () => import("./dialogs/cashOperationSelectDialog"),
  },
  data() {
    return {
      idEdit: 0,
      showEditDialog: false,
      showSelectDialog: false,
      title: "",
      m: this.$store.getters["config/get"].models.cashOut,
      operation: null,
      url: "/accounting/doc/order_withdrawal",
      defaults: {
        sort1: { key: "date_doc", order: "DESC" },
        sort: { key: "id", order: "DESC" },
        paramName: "documentCashOut",
      },
      cashType: null,
      configDoc: null,
      balance: 0,
    };
  },
  created() {
    this.$root.title = "Расходный ордер";
  },
  computed: {
    operations() {
      let res = [];
      this.m.config.forEach(el => {
        if (el.id > 0) res.push(el.id);
      });
      return res;
    },
    permit() {
      return this.getAccess("menu.documentCashOut");
    },
    contextMenuItems() {
      let res = [];
      if (this.$root.profile.role == 1000) res = [{ name: "reStatus2", title: `Перепровести` }];
      return res;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.cashType = null;
        if (this.idEdit) this.$refs.table.updateRowData(this.idItemShow);
        else this.$refs.table.updateData();
        this.idEdit = 0;
      }
    },
  },
  methods: {
    async onContextMenuClick(e) {
      if (e.item.name == "reStatus2") {
        await this.$axios.post(this.url, { id: e.data.id, status: 1 });
        await this.$axios.post(this.url, { id: e.data.id, status: 2 });
        this.$refs.table.updateRowData(e.data.id);
      }
    },
    onRowContextMenu(e) {
      console.log(e.row.status);
      if (e.row.status == 2 && this.$root.profile.role == 1000) {
      } else return;
      this.contextData = e;
      this.$refs.rowContextMenu.showMenu(e.event, e.row);
    },
    async getBalance(filter = {}) {},
    async onSelectOperation(e) {
      console.log("select", e);
      if (!e.value) return;
      this.$refs.cashDialog.openDialog(e.id, 0, {}, { operation_name: e.text });
      return;
      let getConfig = await this.onConfigDocOut(e.id);
      if (!getConfig) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Документ не настроен",
        });
        return;
      }
      this.showEditDialogFun(0);
    },
    async onClickRow(d) {
      this.$refs.cashDialog.openDialog(d.row.operation_type, d.row.id);
      return;
      let getConfig = await this.onConfigDocOut(this.keys?.ctrl ? -1 : d.row.operation_type);
      if (!getConfig) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Документ не настроен",
        });
        return;
      }
      this.showEditDialogFun(d.row.id);

      //  this.$router.push({ name: "ordersGoods_view", params: { id: d.row.id } });
      //      this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.showSelectDialog = true;
    },
  },
};
</script>
